module.exports = __webpack_public_path__ + "img/privilege8.1abfc53c.png";